import { permanentTourUrl } from '../../../common/tour-link';
// Where the listing and the wizard send someone to see a tour's public page, and what to call it. The
// permanent link, which reaches the tour wherever it is shown: on its community's own host, or at its
// link for an organization without one. An unpublished tour opens the same page behind ?preview, which
// the page serves to whoever may manage it; the link carries it through. Unsaved edits are on neither,
// so this follows the saved status.
export const viewAction = (tour) => tour.status === 'active'
    ? { 'href': permanentTourUrl(tour.id), 'label': 'View tour page', 'icon': 'bi-box-arrow-up-right' }
    : { 'href': `${permanentTourUrl(tour.id)}?preview`, 'label': 'Preview tour page', 'icon': 'bi-eye' };
